import React, { useState } from 'react';
import axios from 'axios';
import './PatientRegister.css';

const PatientRegister = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');
  const [gender, setGender] = useState('Male');
  const [age, setAge] = useState('');
  const [error, setError] = useState('');

  const handleRegister = async (e) => {
    e.preventDefault();
    
    // Validate required fields before sending
    if (!name || !email || !password || !age || !gender) {
      setError('Please fill in all required fields: Name, Email, Password, Age, and Gender');
      return;
    }

    try {
      const response = await axios.post('https://turemedicine-backend-1.onrender.com/auth/patient/signup', {
        name,
        email,
        password,
        phone: phone || undefined, // Optional field
        address: address || undefined, // Optional field
        gender,
        age: parseInt(age), // Ensure age is a number
      });

      console.log('Registration Response:', response.data);

      localStorage.setItem('token', response.data.token);
      localStorage.setItem('patientId', response.data.patientId);

      window.location.href = `/patient-dashboard/${response.data.patientId}`; // Redirect to patient dashboard
    } catch (error) {
      console.error('Registration failed:', error);
      if (error.response) {
        setError(error.response.data.error || 'Registration failed. Please try again.');
      } else if (error.request) {
        setError('No response from server. Please check your internet connection or server status.');
      } else {
        setError('An unexpected error occurred. Please try again.');
      }
    }
  };

  return (
    <div className="register-page">
      <div className="auth-container">
        <h2>Patient Registration</h2>
        {error && <p className="error-message">{error}</p>}
        <form onSubmit={handleRegister}>
          <input
            type="text"
            placeholder="Full Name *"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <input
            type="email"
            placeholder="Email *"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password *"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <input
            type="text"
            placeholder="Phone Number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <input
            type="text"
            placeholder="Address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
          <select value={gender} onChange={(e) => setGender(e.target.value)} required>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
          <input
            type="number"
            placeholder="Age *"
            value={age}
            onChange={(e) => setAge(e.target.value)}
            required
            min="1"
            max="150"
          />
          <button type="submit">Register</button>
        </form>
        <p>
          Already have an account?{' '}
          <button 
            onClick={() => window.location.href = '/login?type=patient'} 
            className="link-button"
          >
            Login here
          </button>
        </p>
      </div>
    </div>
  );
};

export default PatientRegister;